import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../../app/api';
import { buildEncodedQueryString, convertToCSVFormat, CSVDataType, downloadCsv } from '../../../../common';
import { PagedResult } from '../../../../store';
import { DownloadSecuritiesPayload, FetchSecurityByIdnPayload, SecuritiesById, SecurityItem, SecurityListParameters } from './types';

export enum SecurityListActionTypes {
  FetchSecurityById =  '@@securities/GetSecuritiesById',
  FetchSecuritylList = '@@security/list/FetchSecurityList',
  DownloadSecurities = '@@security/list/DownloadSecurities',
}

export enum SecurityListApiEndpoints {
  fetchSecurityById = '/securities/GetSecuritiesById',
  fetchSecurityList = '/securities/GetSecurityList',
}

const getSecurityList = async (request: SecurityListParameters) => {
  const body = {
    codeOrNameSearch: request.codeOrNameSearch,
    pagedRequest: request.pagination,
  };

  return await api.post<PagedResult<SecurityItem>>(`${SecurityListApiEndpoints.fetchSecurityList}`, body);
};

export const fetchSecurityList = createAsyncThunk(SecurityListActionTypes.FetchSecuritylList, async (wrapper: SecurityListParameters) => {
  const response = await getSecurityList(wrapper);

  return {
    results: response.data,
    pagination: wrapper.pagination,
  };
});

export const downloadSecurities = createAsyncThunk(SecurityListActionTypes.DownloadSecurities, async (wrapper: DownloadSecuritiesPayload) => {
  const response = await getSecurityList({ ...wrapper, pagination: { ...wrapper.pagination, pageNumber: 1, pageSize: 9999999 } });
  const data: CSVDataType[] = convertToCSVFormat(response.data.results);

  downloadCsv(data, `Securities_`);
  return { message: 'CSV downloaded' };
});

export const fetchSecurityById = createAsyncThunk<
  SecuritiesById[], 
  FetchSecurityByIdnPayload 
>('securities/fetchById', async (request) => {
  const queryString = buildEncodedQueryString({
    securityIds: request.securityId,
  });

  const response = await api.get<SecuritiesById[]>(
    `${SecurityListApiEndpoints.fetchSecurityById}${queryString}`
  );

  return response.data;
});
